export default "__VITE_ASSET__Zr87ORlt__"